 //Prevent VideoJS from adding automatic styles to header.
window.VIDEOJS_NO_DYNAMIC_STYLE = true;

// Import modules from local files if there are no additional dependencies
import {structure} from './structure';
import {subscriptionPage} from './newsletter';
import {printTrigger} from './print-article';
// If moudule has addictional dependencies, import them here dynamically
document.addEventListener("DOMContentLoaded", function(event) {
    structure();
    import('./videojsimport')
    .then(module => {
        module.initPlayers();
    });
    if(document.querySelector('.components-carousel')) {       
        import('./components-carousel')
        .then(module => {
            module.componentsCarousel();
        });
    };
    if(document.querySelector('.full-slide-carousel')) {       
        import('./full-slide-carousel')
        .then(module => {
            module.fullSlideCarousel();
        });
    };
    if(document.querySelector('.graduates-carousel')) {
        import('./saving-lives-carousel')
        .then(module => {
            module.graduatesCarousel();
        });
    };
    if(document.querySelector('.world-class-slider')) {        
        const mql = window.matchMedia('(max-width: 577px)');
        let desktopLoaded = false;
        let mobileLoaded = false;
        if (mql.matches && mobileLoaded == false ) {
            loadWorldClassMobile();
        } else if (desktopLoaded == false) {
            loadWordClassDesktop();
        }
        mql.onchange = (e) => {
            if (e.matches && mobileLoaded == false ) {
                loadWorldClassMobile();
            } else if (desktopLoaded == false ) {
                loadWordClassDesktop();
            }
        }
        function loadWorldClassMobile() {
            import('./centers-thumbnail-carousel-mobile')
                .then(module => {
                    module.worldclassSliderMobile();
            });
            mobileLoaded = true;
        }
        function loadWordClassDesktop() {
            import('./centers-thumbnail-carousel')
                .then(module => {
                    module.worldclassSlider();
            });
            desktopLoaded = true;
        }
    };
        if(document.getElementById('sources-reveal')) {
            import('./resources-pages')
            .then(module => {
                module.resourcesPages();
            });
        };    
        if(document.getElementById('get-help-form')) {
            import('./forms')
            .then(module => {
                if(document.getElementById('get-help-form')) {
                    module.formSubmission();
                }
                if(document.getElementById('phone')) {
                    module.countryCode();
                };     
                if(document.getElementById('country-code-input')) {
                    module.countryCode();
                };
            });
        };
        if(document.querySelector('.video-wall-carousel')) {
            import('./video-wall-carousel')
            .then(module => {
                module.videoWallCarousel();
            });
        }
        if(document.querySelector('.news-slider')) {
            import('./news-thumbnail-carousel')
            .then(module => {
                module.newsSlider();
            });
        };
        if(document.querySelector('.article-simple-slider')) {
            import('./article-simple-carousel')
            .then(module => {
                module.articleSimpleSlider();
            });         
        };
        if(document.querySelector('.center-carousel')) {
            import('./center-carousel')
            .then(module => {
                module.centerCarousel();
            });  
        };
        if(document.querySelector('.main-search')) {
            import('./search')
            .then(module => {
                module.search();
            });  
        };
        // Imports with no dependencys
        if(document.querySelector('#print-article')) {
            const trigger = document.querySelector('#print-article');
            printTrigger(trigger);
        };
        if(document.querySelector('.newsletter-subscription')) {
            subscriptionPage();
        };
        if(document.getElementById('directions')) {
            import('./google-map')
            .then(module => {
                module.getLocation();
            })
        }
}); 

//Start animated Header
document.addEventListener("DOMContentLoaded", async function(event) {
            // If carousel exists, load it (and the Marquee)
            if(document.querySelector('#home_anim_header')) {
                let homeanimate = await import('./animatedheaderpage');
                homeanimate.startShow(true);
                let mediaQuery = window.matchMedia('(min-width: 576px)');
                // Check if the media query is true
                if (mediaQuery.matches) {
                homeanimate.marqueeLoop(true);
                 }
            };

});




